"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_persist_1 = require("redux-persist");
var ProjectActions_1 = require("./ProjectActions");
var server_1 = require("../../helpers/server");
// Initial state values
var initialState = {
    projects: [],
    loading: false,
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(ProjectActions_1.ProjectActions.SEARCH).request:
            return __assign(__assign({}, state), { loading: true });
        case (0, server_1.apiActions)(ProjectActions_1.ProjectActions.SEARCH).success:
            return __assign(__assign({}, state), { projects: action.payload, loading: false });
        case (0, server_1.apiActions)(ProjectActions_1.ProjectActions.SEARCH).fail:
            return __assign(__assign({}, state), { loading: false });
        /* ------------- LOGOUT  ------------------- */
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        /* ------------- END  LOGOUT  ------------------- */
        default:
            return state;
    }
});
